import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import Img, { FluidObject } from 'gatsby-image';
import DefaultContainer from '../../components/DefaultContainer';
import DefaultTitle from '../../components/DefaultTitle';
import DefaultParagraph from '../../components/DefaultParagraph';


const SegregationTile = styled(Img)<{ fluid: FluidObject }>`
  height: 190px;
  width: 190px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    height: 333px;
    width: 333px;
  }
`;

const Title = styled(DefaultTitle)`
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    text-align: left;
    align-self: flex-start;
  }
`;

const ResponsiveContainer = styled(DefaultContainer)`
  display: flex;
  flex-direction: column;
  max-width: 1540px;
  margin: 0 auto;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    flex-direction: row;
    justify-content: space-between;
  }
`;

const Content = styled.div`
  flex: 1;
  max-width: 772px;
`;

const Segregation = () => {
  const theme = useContext(ThemeContext);
  const image = useStaticQuery(graphql`
      query{             
      segregation: file (name: {eq: "segregation"}){
          childImageSharp {
              fluid(quality: 100, maxWidth: 333) {
                  ...GatsbyImageSharpFluid_withWebp
              }
          }
      }
    }      
  `);

  return (
    <ResponsiveContainer>
      <SegregationTile fluid={image.segregation.childImageSharp.fluid} />
      <Content>
        <Title color={theme.colors.dark}>
          Dbamy o czystość i segregację odpadów.
        </Title>
        <DefaultParagraph color={theme.colors.dark}>
          Podczas remontu segregujemy wszystkie śmieci i odpady. Segregacja śmieci do kolorowych
          worków i korzystanie z komunalnych służb ograniczy koszty wywozu śmieci ogólnobudowlanych.
          <br />
          <br />
          Jednocześnie zadbamy o zabezpieczenie lub oklejenie okien i podłóg, jeżeli nie są
          wymieniane - w ten sposób nie zostaną pozostawione ślady po gruncie i farbie. Sprzątanie
          przeprowadzane jest na bieżąco i po pracach.
          <br />
          <br />
          Nie wszystkie odpady remontowe można wyrzucić do ogólnodostępnych śmietników - zajmiemy
          się utylizacją tego typu materiałów.
        </DefaultParagraph>
      </Content>
    </ResponsiveContainer>

  );
};
export default Segregation;
